import { PreventionAction } from "@/entities/prevention-action/model/prevention-action.types"
import { useAppDispatch } from "@/core/root-reducer"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"
import { useState } from "react"
import PreventionActionAddModal, { StepId } from "@/entities/prevention-action/ui/modal/PreventionActionAddModal"
import PreventionActionCard from "@/entities/prevention-action/ui/PreventionActionCard"
import PreventionActionStatusCheck from "@/entities/prevention-action/ui/PreventionActionStatusCheck"
import { isPreventionActionOverdue, isPreventionActionToPlan } from "../model/prevention-action.utils"
import NewlyAddedHighlight from "@/components/NewlyAddedHighlight"
import PreventionActionReadonlyModal from "./modal/PreventionActionReadonlyModal"

interface Props {
  action: PreventionAction
  isNewlyAdded?: boolean
  isReadonly?: boolean
  onReviewPrevention?: (value: number) => void
}

export default function PreventionActionChecklistItem({
  action,
  isNewlyAdded = false,
  isReadonly,
  onReviewPrevention
}: Props) {
  const isToPlan = isPreventionActionToPlan(action)
  const isOverdue = isPreventionActionOverdue(action)
  const dispatch = useAppDispatch()
  const [editModal, setEditModal] = useState<{ initialStep?: StepId } | null>(null)
  const [isReadonlyModalOpen, setIsReadonlyModalOpen] = useState(false)

  function handleOpenModal(initialStep?: StepId) {
    if (isReadonly) return

    dispatch(preventionActionStore.actions.setActive(action))
    setEditModal({ initialStep })
  }

  return (
    <>
      {isReadonlyModalOpen && (
        <PreventionActionReadonlyModal action={action} onClose={() => setIsReadonlyModalOpen(false)} />
      )}
      {editModal && (
        <PreventionActionAddModal
          isEditing
          initialStep={editModal.initialStep}
          onReviewPrevention={onReviewPrevention}
          onClose={() => setEditModal(null)}
        />
      )}
      {/* Toute la carte ouvre la mesure : le PreventionActionStatusCheck stoppe la propagation
          de son clic pour rester un controle a part. */}
      <NewlyAddedHighlight isActive={isNewlyAdded} label="Nouvelle mesure">
        <PreventionActionCard
          control={
            <PreventionActionStatusCheck
              currentStatus={action.cStatus}
              isOverdue={isOverdue}
              isToPlan={isToPlan}
              isReadonly={isReadonly}
              onOpen={() => handleOpenModal(isToPlan ? "DATES" : "STATUS")}
            />
          }
          isDone={action.cStatus === "done"}
          isOverdue={isOverdue}
          isToPlan={isToPlan}
          onClick={isReadonly ? () => setIsReadonlyModalOpen(true) : () => handleOpenModal()}>
          {action.name}
        </PreventionActionCard>
      </NewlyAddedHighlight>
    </>
  )
}
